<template>
  <div class="flex w-full justify-center px-4">
    <div class="flex max-w-[260px] flex-col items-center text-center">
      <component :is="icon" class="size-[34px] text-gray-800" />
      <h2 class="mt-6 text-[20px] leading-[20px] font-medium text-gray-800">
        {{ title }}
      </h2>
      <p class="mt-4 text-[14px] leading-[20px] text-gray-600">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FileAddIcon, FolderIcon } from '@dacr/icons'
import { useUserStore } from '@/shared/stores/user'

const userStore = useUserStore()

const isFirstFile = computed(() => (userStore.user?.totalFiles || 0) === 0)

const icon = computed(() => (isFirstFile.value ? FileAddIcon : FolderIcon))

const title = computed(() =>
  isFirstFile.value ? 'Register your first work' : 'This folder is empty'
)

const subtitle = computed(() =>
  isFirstFile.value
    ? 'Upload to complete your first registration'
    : 'Upload or add registrations to this folder'
)
</script>
